import cloneDeep from 'lodash/cloneDeep'

import {
    MOVE_UP_ACTION,
    MOVE_DOWN_ACTION,
    MOVE_LEFT_ACTION,
    MOVE_RIGHT_ACTION,
    MOVE_SECRET_ACTION,
    SELECT_PLAYER_ACTION,
    SET_GAME_STATE,
    START_GAME_ACTION,
} from '../actions/playerActions'

const cluelessReducer = (state = {}, action) => {
    //let newState = JSON.parse(JSON.stringify(state))
    //let newState = Object.assign({}, state)
    let newState = cloneDeep(state)
    let _player = newState.players[action.player]
    switch(action.type) {
        case MOVE_UP_ACTION:
            if (_player.position[1] <= 0) return state
            newState.players[action.player].position[1] = newState.players[action.player].position[1] - 1
            return newState
        case MOVE_DOWN_ACTION:
            if (_player.position[1] >= 4) return state
            newState.players[action.player].position[1] = newState.players[action.player].position[1] + 1
            return newState
        case MOVE_LEFT_ACTION:
            if (_player.position[0] <= 0) return state
            newState.players[action.player].position[0] = newState.players[action.player].position[0] - 1
            return newState
        case MOVE_RIGHT_ACTION:
            if (_player.position[0] >= 4) return state
            newState.players[action.player].position[0] = newState.players[action.player].position[0] + 1
            return newState
        case SELECT_PLAYER_ACTION:
            newState.activePlayer = action.player
            return newState
        case SET_GAME_STATE:
            newState = action.payload.state
            return newState
        case START_GAME_ACTION:
            newState.started = true
            return newState
        default:
            return state
    }
}

export default cluelessReducer



// WEBPACK FOOTER //
// ./src/reducers/cluelessReducer.jsx